import { FC, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { Menu } from "lucide-react";

import { Footer, Header, MenuMobile, Sidebar } from "./Navigation";
import { useAppSelector } from "../store";
import { AppearedContent } from "./DataDisplay/AppearedContent";
import { Button } from "../ui/layout/molecules/Button";
import { isCompanyViewer } from "./CompanyViewerGate";
import {
  EXTRA_LARGE_ICON_SIZE_STYLES,
  HEADER_BUTTON_STYLES,
} from "../ui/styles";

const CHAT_PAGE_LAYOUT = "h-screen";
const CHAT_PAGE_MAIN = "flex-1 overflow-hidden sm:px-6 sm:py-6 md:px-8 md:py-4";

export const MainLayout: FC = () => {
  const [menuMobileOpen, setMenuMobileOpen] = useState(false);
  const location = useLocation();
  const isSmartDocsPage = location.pathname === "/smart-docs";

  const userId = useAppSelector((state) => state.user.id);
  const actualPermissions = useAppSelector(
    (state) => state.company.company?.featurePermissions,
  );
  const isRestrictedViewer = isCompanyViewer(actualPermissions);
  // restricted viewers see only the CompanyViewerGate notice on smart-docs,
  // so they get the standard padding, not the chat layout.
  const isChatLayout = isSmartDocsPage && !isRestrictedViewer;

  const closeMenuMobile = () => setMenuMobileOpen(false);
  const openMenuMobile = () => setMenuMobileOpen(true);

  return (
    <>
      <MenuMobile
        sidebarOpen={menuMobileOpen}
        closeMenuMobile={closeMenuMobile}
      />
      <div className="hidden bg-stone-50 dark:bg-black md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        <Sidebar />
      </div>
      <Button
        title="Open sidebar"
        customId="menuMobile"
        onClick={() => openMenuMobile()}
        buttonType="iconOnly"
        className={`${HEADER_BUTTON_STYLES} ${EXTRA_LARGE_ICON_SIZE_STYLES} absolute mt-2.5 left-2 top-0 z-20 mr-4 sm:left-4 md:hidden`}
      >
        <Menu />
      </Button>
      <div
        className={`flex flex-1 flex-col dark:bg-[#0E0F09] md:pl-64 ${isChatLayout ? CHAT_PAGE_LAYOUT : "min-h-full"}`}
      >
        <Header />
        <main
          className={`flex w-full flex-col justify-start self-center ${isChatLayout ? CHAT_PAGE_MAIN : "h-full max-w-7xl grow px-4 py-6 sm:px-6 sm:py-8 md:px-8"}`}
        >
          {!!userId ? (
            <Outlet />
          ) : (
            <AppearedContent
              isLoaded={!!userId}
              skeletonOptions={{
                amount: 1,
              }}
            />
          )}
        </main>
        <Footer />
      </div>
    </>
  );
};
